// eslint-disable-next-line import/no-anonymous-default-export
export default {
    //Ofício por Situação
    LIXEIRA: 'Lixeira',
    EM_EDICAO: 'EmEdicao',
    EM_REVISAO: 'EmRevisao',
    EM_CORRECAO: 'EmCorrecao',
    EM_REVISAO_OFICIAL: 'EmRevisaoFinal',
    PARA_ASSINATURA: 'ParaAssinatura',
    PARA_ASSINATURA_PRESIDENTE: 'ParaAssinaturaDoPresidente',
    AGUARDANDO_RECEBIMENTO_PROCESSO_SEI: 'AguardandoRecebimentoProcessoSEI',
    PARA_ENVIO_DE_OFICIO: 'ParaEnvioDeOficio',
    PENDENTE_DE_RECIBO: 'PendentesDeRecibo',

    //Ofícios Enviados
    ENTREGUES: 'OficiosEntregues',
    NAO_ENTREGUES: 'OficiosNaoEntregues',
    COM_CERTIDAO: 'OficiosComCertidaoArt166',
    CERTIDAO_PARA_ASSINATURA: 'OficiosComCertidaoParaAssinatura',
    PARA_JUNTADA: 'OficiosParaConclusao',
    CONCLUIDOS: 'OficiosConcluidos',

    //Protocolo de Ofícios para Envio
    PROTOCOLOS_PENDENTES_DE_ENVIO: 'ProtocolosPendentesDeEnvio',
    PROTOCOLOS_PENDENTES_DE_RECIBO: 'ProtocolosPendentesDeRecibo',
    PROTOCOLOS_PARA_CORRECAO_DE_RECIBO: 'ProtocolosParaCorrecaoDeRecibo',
}